const userEvents = {
  click: 'click',
  blur: 'blur',
  select: 'select',
  change: 'change',
}
export default userEvents
